module.exports = __webpack_public_path__ + "static/coding_real-15c65e31b1ac99d26c594925e2f13bf9.svg";